import { createContext } from 'react';

type IModalContext = {
  guideKey: string | null;
  isOpen: boolean;
  setGuideKey: (guideKey: string) => void;
  setIsOpen: (isOpen: boolean) => void;
};

const initialModalContext: IModalContext = {
  guideKey: null,
  isOpen: false,
  setGuideKey: () => {
    /* empty */
  },
  setIsOpen: () => {
    /* empty */
  },
};

const ModalContext = createContext<IModalContext>(initialModalContext);

export { initialModalContext, ModalContext, type IModalContext };
